import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ArrowRightIcon } from 'lucide-react';
interface HeroSectionProps {
  onOpenDemo: () => void;
}
export function HeroSection({
  onOpenDemo
}: HeroSectionProps) {
  return <section className="relative w-full bg-stark-white pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-145" data-mp="23wcwlwf6vyit">
      <div aria-hidden="true" className="absolute top-0 right-0 w-[45%] h-full bg-cool-gray -skew-x-12 translate-x-40 pointer-events-none" data-id="element-146" data-mp="28uo8ecp1oj3o" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-147" data-mp="30lu50j5k3yo7">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-148" data-mp="30n55oa3pgqb3">
          <div className="space-y-8" data-id="element-149" data-mp="2mt4bltnp7rh2">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} className="inline-flex items-center gap-2 px-4 py-1.5 bg-royal-blue/10 rounded-full" data-id="element-150" data-mp="2ms2zrmyuz0ya">
              <span className="w-1.5 h-1.5 rounded-full bg-royal-blue" data-id="element-151" data-mp="2beq1wy4ycysp" />
              <span className="text-royal-blue text-xs font-bold uppercase tracking-widest" data-id="element-152" data-mp="2p5bn4thvpktr">
                Business Performance Platform
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.1,
            ease: 'easeOut'
          }} className="text-midnight-navy text-4xl md:text-6xl font-montserrat font-extrabold leading-[1.05] tracking-tight" data-id="element-153" data-mp="2kcs9xxn3srph">
              Unlock the Full Potential of Your Business
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.2,
            ease: 'easeOut'
          }} className="text-midnight-navy/60 text-lg md:text-xl leading-relaxed max-w-xl" data-id="element-154" data-mp="18smsxnw1hd09">
              ROI Complete helps businesses increase profitability, streamline
              operations, and make smarter decisions through data-driven
              consulting and technology.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.7,
            delay: 0.3,
            ease: 'easeOut'
          }} className="flex flex-col sm:flex-row gap-4" data-id="element-155" data-mp="5c2wdiom5qyj">
              <button onClick={onOpenDemo} className="group bg-royal-blue text-stark-white px-8 py-4 rounded-full font-bold hover:bg-royal-blue-dark transition-all shadow-xl shadow-royal-blue/20 active:scale-95 flex items-center justify-center gap-2" data-id="element-156" data-mp="23vhgnp9l638a">
                Schedule a Consultation
                <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-157" data-mp="1pwzuhvzbwysh" />
              </button>
              <button onClick={onOpenDemo} className="group border border-midnight-navy/15 text-midnight-navy px-8 py-4 rounded-full font-bold hover:bg-cool-gray transition-all active:scale-95 flex items-center justify-center gap-3" data-id="element-158" data-mp="2ijkmmynmpex3">
                <span className="w-8 h-8 rounded-full bg-midnight-navy text-stark-white flex items-center justify-center group-hover:bg-royal-blue transition-colors" data-id="element-159" data-mp="28rojh96oqym0">
                  <PlayIcon className="w-3 h-3 ml-0.5" data-id="element-160" data-mp="31glucr8kht4q" />
                </span>
                Watch Demo
              </button>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96,
          y: 24
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.25,
          ease: 'easeOut'
        }} className="relative" data-id="element-161" data-mp="2q20lu9196psx">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/e1434989-ade5-4a3c-bbcf-b7c2249a9c9a.jpg" alt="ROI Complete executive dashboard showing revenue, margin, labor and inventory metrics" className="w-full h-auto rounded-2xl shadow-2xl shadow-midnight-navy/15 border border-midnight-navy/5" data-id="element-162" data-mp="38qyk9j3lh9ti" />

            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 hidden sm:block bg-stark-white rounded-2xl shadow-xl shadow-midnight-navy/10 border border-midnight-navy/5 px-6 py-4" data-id="element-163" data-mp="3sgr56j7zdjbo">
              <div className="text-xs font-bold uppercase tracking-widest text-midnight-navy/40 mb-1" data-id="element-164" data-mp="ahoi761yogwl">
                Net Margin
              </div>
              <div className="flex items-baseline gap-2" data-id="element-165" data-mp="3eulbfgvt583d">
                <span className="text-2xl font-montserrat font-extrabold text-midnight-navy" data-id="element-166" data-mp="3ew64t36dykzn">
                  +4.2%
                </span>
                <span className="text-xs font-bold text-royal-blue" data-id="element-167" data-mp="3nv9r0g0ungid">
                  This quarter
                </span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}